<template>
  <div class="container">
    <div class="login-box">
      <!-- 左边 -->
      <div class="left-box">
        <img src="@/assets/slogn.png" alt="" />
      </div>
      <!-- 右边 -->
      <div class="right-box">
        <div class="logo">
          <img src="@/assets/logo.png" alt="" />
        </div>
        <p>法鼎商事调解中心.管理后台</p>
        <div class="input-box">
          <img src="@/assets/account.png" class="prefix-icon" alt="" />
          <el-input
            placeholder="请输入账号"
            type="text"
            v-model="account"
            class="input-inner"
          ></el-input>
        </div>
        <div class="input-box">
          <img src="@/assets/password.png" class="prefix-icon" alt="" />
          <el-input
            placeholder="请输入密码"
            :type="hiddenPwd ? 'password' : 'text'"
            v-model="password"
            class="input-inner"
          ></el-input>
          <img
            :src="hiddenPwd ? passHide : passShow"
            alt=""
            class="prefix-icon"
            @click="showPassword"
          />
        </div>
        <el-button type="primary" round class="login-btn" @click="login"
          >登录</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      account: "",
      password: "",
      hiddenPwd: true,
      passShow: require("@/assets/pass_show.png"),
      passHide: require("@/assets/pass_hide.png"),
    };
  },
  methods: {
    showPassword() {
      this.hiddenPwd = !this.hiddenPwd;
    },
    async login() {
      // 数据校验
      if (this.account == "" || this.password == "") {
        this.$message.error("请输入用户名和密码");
        return;
      }
      let loginForm = {
        username: this.account,
        password: this.password,
      };
      try {
        const { data: res } = await this.$http.post("login", loginForm);
        // console.log(res);
        if (res.meta.status !== 200) {
          return this.$message.error("登录失败");
        }
        this.$message.success("登录成功");
        window.sessionStorage.setItem("token", res.data.token);
        this.$router.push("/index");
      } catch (e) {
        this.$message.error(e);
      }
    },
  },
};
</script>
<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  background-color: #f3f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-box {
  width: 1000px;
  height: 600px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
}
.left-box {
  width: 424px;
  background-color: #333;
}
.left-box img {
  width: 100%;
  height: 100%;
}
.right-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo {
  width: 34px;
  height: 46px;
  margin-top: 90px;
  border-radius: 50%;
}
.logo img {
  width: 100%;
  height: 100%;
}
.right-box p {
  font-size: 24px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #272727;
  margin-bottom: 40px;
}
.input-box {
  width: 328px;
  height: 50px;
  background: #f1f2f7;
  border-radius: 25px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
}
.prefix-icon {
  height: 23px;
  width: 23px;
  margin: 0 3px 0 22px;
}
.input-inner {
  width: 200px;
}
>>> .el-input__inner {
  border: none;
  outline: none;
  font-size: 14px;
  background: #f1f2f7;
}
.login-btn {
  width: 328px;
  height: 45px;
  margin-top: 25px;
  box-sizing: border-box;
}
</style>